import { Turbo } from "@hotwired/turbo-rails";
import "packs/engines/subscriber_v2/controllers";
import "trix";
import ujs from "@rails/ujs";
import "utils/frame_missing_handler";
import { logEvent, setUserProperties, identify, startSessionRecording } from "utils/analytics";
import { showToast } from "utils/toast";
import PlaybackDb from "./playback_database";
import * as queueDb from "./queue_database";
import "./service_worker_registration";

ujs.start();

if (document.cookie.indexOf('sc_debug') !== -1) {
  startSessionRecording();
}

window.playbackDb = new PlaybackDb();
window.queueDb = queueDb;
window.Turbo = Turbo;
window.analytics = { logEvent, setUserProperties, identify };
window.showToast = showToast;
